(function($) { 
  $(".hm-video video").prop("muted", true);
  var homepage_video_triggred = false;
  $(window).scroll(function(e){
    if(!$(".hm-video video").length) return;
    if($(".hm-video video") && isInView($(".hm-video video")) && !homepage_video_triggred){
      homepage_video_triggred = true;
      //$(".hm-video").trigger("click");
      $(".hm-video img").fadeOut();
      $(".hm-video video").prop("muted", true);
      $(".hm-video video").get(0).play();
      $(".hm-video video").trigger("click");
    }
  });
  var timeout_handle = null;
  $(window).on("resize", function(e){
    if(timeout_handle != null) clearTimeout(timeout_handle)
    timeout_handle = setTimeout(handleHsFormContainerHeight, 100);
  });
  $(window).on("load", function(e){
    if(timeout_handle != null) clearTimeout(timeout_handle)
    timeout_handle = setTimeout(handleHsFormContainerHeight, 500);
  });
  function handleHsFormContainerHeight(){
    $(".hs-form-frame").each(function(index,element){      
      var iframe_height = $(element).find("iframe").outerHeight(true);
      $(element).css("height", (iframe_height+75)+"px");
      console.log(iframe_height);
    });
  }
  function isInView(elem){
    return $(elem).offset().top - $(window).scrollTop() < $(elem).height();
  }
})(jQuery);